import { Component, Inject } from '@angular/core';

import { ApplicationFacade } from '@ridango/components';
import { AuthService } from '@ridango/core';

import { HelperService } from '../../../services/helper.service';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-footer-template-gl',
    templateUrl: './footer-template-gl.component.html'
})
export class FooterTemplateGlComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;

    footerActions: string[] = this.env.FOOTER.ACTIONS;
    footerSupportActions: string[] = this.env.FOOTER.SUPPORT_ACTIONS;
    footerSocialLinks: string[] = this.env.FOOTER.SOCIAL_LINKS;

    constructor(
        private applicationFacade: ApplicationFacade,
        public ridangoAuth: AuthService,
        @Inject('ENV') public env: Env,
        public helperService: HelperService
    ) {}
}
